class FixedAtc extends HTMLElement {
  constructor() {
    super();
    this.target = document.getElementById(this.dataset.target);

    if (this.target) {
      this.addEventListener('click', this.handleClick.bind(this));
      this.initIntersectionObserver();
    }
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        // Toggle the visibility
        if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
          this.classList.remove('translate-y-full', 'opacity-0');
        } else {
          this.classList.add('translate-y-full', 'opacity-0');
        }
      },
      {
        root: null,
        threshold: 0,
      },
    );

    observer.observe(this.target);
  }

  handleClick() {
    this.target.scrollIntoView({ behavior: 'smooth' });
  }
}

customElements.define('fixed-atc', FixedAtc);
